<template>
  <div class="markets">
    <header-box :title="title" :intro="intro"></header-box>
    <div class="markets__innerwrap">
      <div class="markets__blocks">
        <div class="markets__block" v-for="block in contentBlocks">
          <div class="markets__block-image-wrapper" v-if="(block.type === 'image')">
            <movie-player v-if="block.video" class="markets__block-video" :movieUrl="block.video" :placeholderUrl="block.image" autoplay="true"></movie-player>
            <img v-if="!block.video" class="markets__block-image" :src="block.image" />
          </div>
          <div class="markets__block-textwrap" v-if="(block.type === 'text')">
            <h2 class="markets__block-title" v-html="block.title"></h2>
            <h3 v-if="block.subtitle" class="markets__block-subtitle" v-html="block.subtitle"></h3>
            <div class="markets__block-content" v-html="block.content"></div>
          </div>
        </div>
      </div>

      <div class="markets__blocks markets__blocks--mobile">
        <div class="markets__block" v-for="block in mobileContentBlocks">
          <div class="markets__block-image-wrapper" v-if="(block.type === 'image')">
            <movie-player v-if="block.video" class="markets__block-video" :movieUrl="block.video" :placeholderUrl="block.image" autoplay="true"></movie-player>
            <img v-if="!block.video" class="markets__block-image" :src="block.image" />
          </div>
          <div class="markets__block-textwrap" v-if="(block.type === 'text')">
            <h2 class="markets__block-title" v-html="block.title"></h2>
            <h3 class="markets__block-subtitle" v-html="block.subtitle"></h3>
            <div class="markets__block-content" v-html="block.content"></div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import PrevNextNav from '@/components/PrevNextNav';
import HeaderBox from '@/components/HeaderBox';
import MoviePlayer from '@/components/MoviePlayer';

export default {
  name: 'markets',
  components: { PrevNextNav, HeaderBox, MoviePlayer },
  data() {
    return {
      innerWidth: window.innerWidth,
    };
  },
  computed: {
    ...mapGetters(['page']),
    title() {
      return this.page.title;
    },
    intro() {
      return this.page.intro;
    },
    contentBlocks() {
      return this.page.contentBlocks;
    },
    mobileContentBlocks() {
      const contentBlocks = this.page.contentBlocks.slice();

      [].forEach.call(contentBlocks, (contentBlock, index) => {
        if (index % 2 === 1 && contentBlocks[index].type === 'image' && contentBlocks[index - 1].type === 'text') {
          const tempFirst = contentBlocks[index];
          const tempSec = contentBlocks[index - 1];
          contentBlocks[index] = tempSec;
          contentBlocks[index - 1] = tempFirst;
        }
      });

      return contentBlocks;
    },
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.innerWidth = window.innerWidth;
    });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '../../scss/helpers';

.markets {
  @include page(false);

  &__blocks {
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
    box-sizing: border-box;
    padding: 20px 0 0;

    @include mobile {
      display: none;

      &--mobile {
        display: block;
      }
    }


    @include not-mobile {
      padding: 40px 0;

      &--mobile {
        display: none;
      }
    }
    
    @include landscape {
      display: flex;
      padding: 20px 0 0;

      &--mobile {
        display: none;
      }
    }
  }

  &__block {
    display: block;
    width: 100%;
    box-sizing: border-box;

    @include tablet {
      width: 75%;

      &:nth-child(2n) {
        margin-left: 25%;
        margin-bottom: 60px;
      }

      &:nth-child(2n+1) {
        margin-right: 25%;
      }
    }

    @include landscape {
      width: 50%;
      margin-bottom: 20px;

      &:nth-child(2n) {
        margin-left: 0;
        margin-bottom: 20px;
      }

      &:nth-child(2n+1) {
        margin-right: 0;
      }
    }

    @include not-tablet {
      width: 50%;
    }
  }

  &__block-image-wrapper {
    display: block;
    width: calc(100% - 40px);
    // background-size: cover;
    // background-position: center;
    position: relative;
    margin: auto;
    overflow: hidden;

    // &::before {
    //   content: '';
    //   display: block;
    //   padding-top: 56.25%;
    // }

    @include landscape {
      width: calc(100% - 20px);
    }
  }

  @include not-mobile {
    &__block:nth-child(2n) &__block-image-wrapper {
      margin-right: 40px;
    }

    &__block:nth-child(2n+1) &__block-image-wrapper {
      margin-left: 40px;
    }
  }

  &__block-image {
    display: block;
    width: 100%;
  }

  // &__block-video {
    // width: 100%; 
    // height: 100%;
    
    // /* Center the video */
    // position: absolute;
    // top: 0;
    // left: 0;
    // transition: opacity .5s;

    // &.hide {
    //   opacity: 0;
    //   pointer-events: none;
    // }
  // }

  @include landscape {
    &__block:nth-child(2n) &__block-image {
      margin-right: 20px;
      margin-left: 0;
    }

    &__block:nth-child(2n+1) &__block-image {
      margin-left: 20px;
      margin-right: 0;
    }
  }


  &__block-textwrap {
    background: $c_white;

    @include mobile {
      width: calc(100% - 20px);
      box-sizing: border-box;
      padding: 40px 30px 40px 60px;
      margin-bottom: 20px;
    }

    @include not-mobile {
      padding: 50px 40px 50px 80px;
    }

    @include landscape {
      box-sizing: border-box;
      padding: 40px 30px 40px 60px;
      width: auto;
      margin-bottom: 0;
    }
  }

  @include tablet {
    &__block:nth-child(2n) &__block-textwrap {
      padding: 80px 40px 30px 80px;
      margin-top: -40px;
    }

    &__block:nth-child(2n+1) &__block-textwrap {
      padding: 40px 40px 70px 80px;
      margin-bottom: -40px;
    }
  }

  @include landscape {
    &__block:nth-child(2n) &__block-textwrap {
      padding: 40px 30px 40px 60px;
      margin-top: 0;
    }

    &__block:nth-child(2n+1) &__block-textwrap {
      padding: 40px 30px 40px 60px;
      margin-bottom: 0;
    }
  }

  &__block-title {
    @include font-block-title;

    &::before {
      content: '';
      display: block;
      position: absolute;
      left: -40px;
      width: 20px;
      height: 2px;
      background: $c_primary;
      top: 9px;
    }
  }

  &__block-subtitle {
    margin: 1.5em 0 0;
    font-size: 12px;
    font-weight: 600;
    line-height: 2;
    color: $c_primary;
  }

  &__block-content {
    @include font-block-content;
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/templates/Markets.vue